// ============================================================
// 🧩 CLIENT-WISE MODULES
// ============================================================
// Ek hi codebase, har client deployment apne modules on karta hai.
// `.env` me set karo (comma separated):
//
//   REACT_APP_MODULES=logistics,pharma            → Aarogya jaisa client
//   REACT_APP_MODULES=fintech_lending             → NBFC client
//   REACT_APP_MODULES=all                         → sab kuch
//
// Env set nahi hai to DEFAULT_MODULES chalte hain (purana behaviour).
// Core (dashboard, leads, dialer, WhatsApp, employees, attendance,
// targets, analytics, settings) hamesha on rehta hai.
//
// Module off hai to: sidebar me nahi dikhega + route "Module not enabled"
// dikhayega — ADMIN ke liye bhi (ye permission nahi, deployment config hai).
// ============================================================

export const MODULES = {
  logistics: 'logistics',             // orders → verify → dispatch → NDR/RTO, billing
  pharma: 'pharma',                   // products, stock, purchase, vendors, centers
  fintech_lending: 'fintech_lending', // NBFC: loans, EMI, collections
  fintech_dsa: 'fintech_dsa',         // DSA: loan sourcing → lender → commission
};

const DEFAULT_MODULES = [MODULES.logistics, MODULES.pharma, MODULES.fintech_lending];

/** Route prefix → module. Jo route yahan nahi hai wo core hai (hamesha on). */
const MODULE_ROUTE_PREFIXES = {
  [MODULES.logistics]: [
    '/orders',
    '/order-details',
    '/verified',
    '/ManualAssignPanel',
    '/DispatchOrder',
    '/DispatchOrderverified',
    '/dispatched',
    '/dispatch-failed',
    '/InTransit',
    '/OFDOrders',
    '/DeliveredOrders',
    '/NDROrders',
    '/NDRRequest',
    '/ndr',
    '/rto',
    '/dashboard/order',
    '/billing',                 // invoices orders ke hi hote hain
    '/settings/courier-api',
    '/settings/velocity-warehouse',
  ],
  [MODULES.pharma]: [
    '/products',
    '/stock-management',
    '/purchase',
    '/b2b-partners',
    '/centers',
    '/ledger',
  ],
  [MODULES.fintech_lending]: ['/fintech'],
  [MODULES.fintech_dsa]: ['/dsa'],
};

const parseEnabledModules = () => {
  const raw = (process.env.REACT_APP_MODULES || '').trim();
  if (!raw) return new Set(DEFAULT_MODULES);
  if (raw.toLowerCase() === 'all') return new Set(Object.values(MODULES));

  const known = new Set(Object.values(MODULES));
  const enabled = raw
    .split(',')
    .map((m) => m.trim().toLowerCase())
    .filter(Boolean);

  enabled
    .filter((m) => !known.has(m))
    .forEach((m) => console.warn(`REACT_APP_MODULES: unknown module "${m}" ignored`));

  return new Set(enabled.filter((m) => known.has(m)));
};

// Build time pe env fix hota hai, isliye ek hi baar parse karo
const ENABLED = parseEnabledModules();

export const isModuleEnabled = (module) => ENABLED.has(module);

/** Is pathname ka module kaunsa hai? null = core route. */
export const getRouteModule = (pathname) => {
  const p = String(pathname || '/').split('?')[0].split('#')[0].toLowerCase();
  for (const [module, prefixes] of Object.entries(MODULE_ROUTE_PREFIXES)) {
    const hit = prefixes.some((prefix) => {
      const pre = prefix.toLowerCase();
      return p === pre || p.startsWith(`${pre}/`);
    });
    if (hit) return module;
  }
  return null;
};

/** Route ka module on hai (ya core route hai)? */
export const isRouteEnabled = (pathname) => {
  const module = getRouteModule(pathname);
  return module === null || isModuleEnabled(module);
};
